import { FiStar } from 'react-icons/fi';

const ReviewForm = ({ value, onChange, onSubmit, onCancel }) => (
  <form onSubmit={onSubmit} className="border border-gray-200 rounded p-4 mb-4">
    <span className="flex gap-1 mb-3">
      {[1, 2, 3, 4, 5].map((s) => (
        <button
          type="button"
          key={s}
          onClick={() => onChange({ ...value, rating: s })}
          aria-label={`Rate ${s} star${s > 1 ? 's' : ''}`}
        >
          <FiStar
            className={`text-xl ${
              s <= value.rating ? 'text-orange-400 fill-orange-400' : 'text-black'
            }`}
          />
        </button>
      ))}
    </span>
    <textarea
      rows={3}
      value={value.text}
      onChange={(e) => onChange({ ...value, text: e.target.value })}
      required
      minLength={10}
      placeholder="Share your experience with this product..."
      className="w-full border border-gray-300 rounded p-2 text-sm focus:outline-none focus:border-orange-500"
    />
    <div className="flex gap-2 mt-2">
      <button type="submit" className="bg-orange-500 text-white text-sm px-4 py-1.5 rounded">
        Submit
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="border border-gray-300 text-black text-sm px-4 py-1.5 rounded"
      >
        Cancel
      </button>
    </div>
  </form>
);

export default ReviewForm;
